import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const EsignPrivateRoute = () => {
    const isLoggedIn = getUserToken()

    if (!isLoggedIn) {
        return <Navigate to="/esign/login" replace />
    }

    return <Outlet />
}

export default EsignPrivateRoute